module.exports = __webpack_public_path__ + "static/media/Univers.25c1e0ad.woff";